import { Component, OnInit } from '@angular/core';
import { SimpayxOrder } from '../../models/simpayx-order.model';
import { CustomerAddress, CustomerInput } from '../../models/customer.model';
import { StorageService } from '../../services/storage.service';
import { AlertController, ModalController } from '@ionic/angular';
import { CustomerService } from '../../services/customer.service';
import { LoadingService } from '../../services/loading.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { Router } from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'simpayx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  pageDetails = { title: 'Add your information', page: 'login' };
  simpayxOrder!: SimpayxOrder;
  customerAddress!: CustomerAddress;
  customerDetails!: CustomerInput;
  isLoggedIn: boolean = false;
  restaurantHomePageURL: string;
  constructor(
    private storageService: StorageService,
    private modalController: ModalController,
    private alertController: AlertController,
    private customerService: CustomerService,
    private loadingService: LoadingService,
    private location: Location
  ) {}

  ngOnInit() {
    this.customerService
      .getCustomerAsObservable()
      .subscribe((customer: CustomerInput) => {
        this.customerDetails = customer;
      });
    this.isCustomerLoggedIn();
  }

  async loginSuccess(event: any) {
    this.loadingService.presentLoading('Please wait..!');

    if (event.loggedIn) {
      this.loadingService.dismiss();
      this.customerDetails = JSON.parse(
        this.storageService.getLocalStorageData(LOCAL_STORAGE.CUSTOMER_DETAILS)
      )
        ? (this.customerDetails = JSON.parse(
            this.storageService.getLocalStorageData(
              LOCAL_STORAGE.CUSTOMER_DETAILS
            )
          ))
        : null;
      this.isLoggedIn = true;
      this.loggedInPopup(event.loggedIn);
      // this.modalController.dismiss(event);
    } else {
      this.loadingService.dismiss();
      this.somethingWentWrong();
    }
  }

  async loggedInPopup(loggedIn: boolean) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: loggedIn ? 'Logged in Successfully!' : 'something went wrong!',
      backdropDismiss: false,
      mode: 'ios',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            if (loggedIn) {
              const businessId = this.storageService.getLocalStorageData(
                LOCAL_STORAGE.BUSINESS_VALUES
              ).businessId;
              const merchantId = this.storageService.getLocalStorageData(
                LOCAL_STORAGE.BUSINESS_VALUES
              ).merchantId;
              // const baseUrl = 'simpayx/logistic';
              // const queryParams = `merchantId=${merchantId}&businessId=${businessId}`;
              // this.restaurantHomePageURL = `${baseUrl}?${queryParams}`;
              // window.location.href = this.restaurantHomePageURL;
              this.location.back();
            }
          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
  }

  async somethingWentWrong() {
    const alert = await this.alertController.create({
      header: 'Alert',
      subHeader: 'Something went wrong!!!',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            console.log('Confirm Okay');

            this.modalController.dismiss();
          },
        },
      ],
    });

    await alert.present();
    const { role } = await alert.onDidDismiss();

    console.log('onDidDismiss resolved with role', role);
  }

  isCustomerLoggedIn() {
    let customerId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.CUSTOMER_ID
    );
    this.isLoggedIn = customerId ? true : false;
  }
}
